<template>
  <div class="module-container utilization-container">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <div
          class="main-image-container bg-purple rounded d-flex justify-content-center align-items-center"
        >
          <img
            height="25"
            width="25"
            :src="require('../../assets/icons/clipboards.svg')"
          />
        </div>
        <h3 class="mb-0 ml-3">Utilization</h3>
      </div>
      <div class="flex">
        <b-button
          class="smaller-button button-custom-blue"
          variant="primary"
          size="sm"
          @click="addUR"
          ><i class="fa fa-plus mr-2" aria-hidden="true"></i> New
          Review</b-button
        >
      </div>
    </div>
    <div class="filters-container" ref="filtersContainer">
      <div
        class="d-flex flex-row justify-content-between align-items-center bg-light-gray min-width-fit-content"
      >
        <div class="d-flex flex-wrap align-items-center">
          <span class="ml-4 mr-3" style="font-size: 14px;"
            >Active filters:</span
          >
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(c, cIndex) in filterEoc"
            :key="c.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Patient: <span class="color-filter">{{ c.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeClientFilter(cIndex)"
              ></i>
            </div>
          </div>
          <div
            v-if="filter.reviewDateFrom || filter.reviewDateTo"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Review date:
                <span class="color-filter"
                  >{{
                    filter.reviewDateFrom || filter.reviewDateTo
                      ? `(${
                          filter.reviewDateFrom
                            ? "From: " + formatDateOnly(filter.reviewDateFrom)
                            : ""
                        }${
                          filter.reviewDateFrom && filter.reviewDateTo
                            ? " - "
                            : ""
                        }${
                          filter.reviewDateTo
                            ? "To: " + formatDateOnly(filter.reviewDateTo)
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeReviewDateFilter()"
              ></i>
            </div>
          </div>
          <div
            v-if="filter.dueDateFrom || filter.dueDateTo"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Next review date (Due date):
                <span class="color-filter"
                  >{{
                    filter.dueDateFrom || filter.dueDateTo
                      ? `(${
                          filter.dueDateFrom
                            ? "From: " + formatDateOnly(filter.dueDateFrom)
                            : ""
                        }${
                          filter.dueDateFrom && filter.dueDateTo ? " - " : ""
                        }${
                          filter.dueDateTo
                            ? "To: " + formatDateOnly(filter.dueDateTo)
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeDueDateFilter()"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(l, lIndex) in filter.levelOfCare"
            :key="l.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Level fo care:
                <span class="color-filter">{{ l.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeLevelOfCareFilter(lIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(s, sIndex) in filter.status"
            :key="s.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Status: <span class="color-filter">{{ s.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeStatusFilter(sIndex)"
              ></i>
            </div>
          </div>
          <div
            v-if="filter.creationDateFrom || filter.creationDateTo"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Creation date:
                <span class="color-filter"
                  >{{
                    filter.creationDateFrom || filter.creationDateTo
                      ? `(${
                          filter.creationDateFrom
                            ? "From: " + formatDateOnly(filter.creationDateFrom)
                            : ""
                        }${
                          filter.creationDateFrom && filter.creationDateTo
                            ? " - "
                            : ""
                        }${
                          filter.creationDateTo
                            ? "To: " + formatDateOnly(filter.creationDateTo)
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeCreationDateFilter()"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(cB, cBIndex) in filterCreatedBy"
            :key="cB.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Created by:
                <span class="color-filter">{{ cB.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeCreatedByFilter(cBIndex)"
              ></i>
            </div>
          </div>
          <span
            v-if="hasFilters"
            class="clear-all-filters text-danger ml-2"
            style="font-size: 14px;"
            @click="clearAllFilters"
            >Clear all filters</span
          >
        </div>
        <div class="d-flex align-self-stretch align-items-center">
          <div class="align-self-stretch" style="padding: 9px 0px;">
            <div class="vertical-separator border-med-light-gray"></div>
          </div>
          <b-dropdown
            id="dropdown-form"
            text="Filters"
            ref="filterDropdown"
            class="container-main bg-light-gray"
            toggle-class="d-flex flex-row justify-content-between align-items-lg-center bg-transparent border-0 color-custom-dark-grey dropdown-menu-label"
            menu-class="container-filter-main-menu"
            toggle-tag="div"
            boundary="window"
            right
            @hide="onFilterHide"
          >
            <template #button-content>
              <div class="d-flex align-items-center mr-2">
                <i
                  class="fas fa-filter text-primary mr-2"
                  style="font-size: 15px;"
                  aria-hidden="true"
                ></i>
                <span style="font-size: 14px;">Filters</span>
              </div>
            </template>
            <b-dropdown-form class="px-2">
              <b-form-group label="Filter by:">
                <b-form-select
                  v-model="selectedFilter"
                  :options="filterOptions"
                />
              </b-form-group>
              <multiple-select-filter
                v-if="selectedFilter == 'patient'"
                :label="'Patients'"
                v-model="filter.eoc"
                :options="clientOptions"
                :width="filterWidth()"
                :showSearch="true"
                :async="true"
                :searching="clientSearchChanged"
                @on-search="fetchClientOptions"
                @on-text-selection="updateTextSelection"
                placeholder="Type Patient Name or MR#..."
                :key="'patient'"
                ref="patientFilter"
              >
                <template v-slot:item-option="{ itemOption, selected }">
                  <eoc-filter-option-template
                    :eoc="itemOption.data"
                    :selected="selected"
                  />
                </template>
              </multiple-select-filter>
              <date-range-filter
                v-if="selectedFilter == 'reviewDate'"
                v-model="filterReviewDateRange"
                :filterWidth="filterWidth"
                label="Review Date"
                :key="'reviewDate'"
              />
              <date-range-filter
                v-if="selectedFilter == 'dueDate'"
                v-model="filterDueDateRange"
                :filterWidth="filterWidth"
                label="Next review date (Due date)"
                :key="'dueDate'"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'levelOfCare'"
                :label="'Level of care'"
                :options="levelsOfCare"
                v-model="filter.levelOfCare"
                :width="filterWidth()"
                :showSearch="false"
                :key="'levelOfCare'"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'status'"
                :label="'Status'"
                :options="utilizationStatuses"
                v-model="filter.status"
                :width="filterWidth()"
                :showSearch="false"
                :key="'status'"
              />
              <date-range-filter
                v-if="selectedFilter == 'creationDate'"
                v-model="filterCreationDateRange"
                :filterWidth="filterWidth"
                label="Creation Date"
                :key="'creationDate'"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'createdBy'"
                :label="'Created by'"
                :options="users"
                v-model="filterCreatedBy"
                :width="filterWidth()"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'createdBy'"
                ref="createdByFilter"
              />
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-0 w-100 d-flex flex-row justify-content-between">
      <div class="d-flex align-items-center" style="font-size: 19px;">
        <div class="">
          <a
            v-if="hasCurrentUserReportPermission('Utilization')"
            class="hover-pointer"
            style="font-size: 14px"
            @click="showReportRequestsModal = true"
          >
            <i class="fa fa-download"></i>
            <span class="ml-2 text-primary" style="font-size: 14px"
              >Export</span
            >
          </a>
        </div>
        <div
          v-if="
            currentUser &&
              !currentUser.onlyAccessAssignedPatients &&
              hasCurrentUserReportPermission('Utilization')
          "
          class="border-left border-med-light-gray pl-1 ml-1 mr-1"
          style="width: 1px; height: 19px"
        ></div>
        <vue-toggles
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          @click="changeAssignedToMEToggle"
          :value="assignedToMe"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          class="ml-2"
          >Show My Patients only</small
        >
      </div>
      <div class="d-flex flex-row justify-content-end align-items-center">
        <top-paginator
          :total="listTotal"
          :page="filter.page"
          :perPage="filter.pageSize"
          @change-page="changePage"
        />
      </div>
    </div>
    <div
      :style="
        `--document-list-filters-container-height:calc(${filtersContainerHeight}px);`
      "
    >
      <grid
        :columns="columns"
        :data="items"
        :store="gridConfig.store"
        :selectionMode="gridConfig.selectionMode"
        :columnLines="gridConfig.columnLines"
        :groupFeature="false"
        :autoHeight="false"
        :searchFeature="true"
        :stripeFeature="false"
        @storesort="listeners.storeSort"
        @renderrows="hookDropdownButtons"
        @renderrow="hookDropdownButtons"
      />
    </div>
    <utilization-add-edit-modal
      v-if="showAddUREditor"
      v-model="showAddUREditor"
      @onModify="onModifyAddUR"
      @onNextReview="onCreateNew"
      :urId="editUR.id"
      :lastUrId="editUR.lastUrId"
    />
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
      :reportFilters="exportFilter"
      reportName="Utilization"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import urRecordServer from "../../server/urRecord";
import eocServer from "../../server/eoc";
import userServer from "../../server/user";
import {
  formatDateOnly,
  formatDate,
  formatStartDateSql,
  formatEndDateSql
} from "../../helpers/date";
import UtilizationAddEditModal from "./UtilizationAddEditModal.vue";
import TopPaginator from "../controls/TopPaginator.vue";
import EocFilterOptionTemplate from "../../views/EocFilterOptionTemplate";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";

export default {
  name: "UtilizationsIndex",
  components: {
    Grid,
    TopPaginator,
    UtilizationAddEditModal,
    EocFilterOptionTemplate,
    ReportRequestIndex
  },
  props: ["category", "showing"],
  data() {
    const self = this;
    return {
      list: [],
      listTotal: 0,
      selectedFilter: "patient",
      filterOptions: [
        {
          value: "patient",
          text: "Patient"
        },
        {
          value: "reviewDate",
          text: "Review date"
        },
        {
          value: "dueDate",
          text: "Next review date (Due date)"
        },
        {
          value: "levelOfCare",
          text: "Level of care"
        },
        {
          value: "status",
          text: "Status"
        },
        {
          value: "creationDate",
          text: "Creation date"
        },
        {
          value: "createdBy",
          text: "Created by"
        }
      ],
      filter: {
        eoc: [],
        reviewDateFrom: null,
        reviewDateTo: null,
        dueDateFrom: null,
        dueDateTo: null,
        levelOfCare: [],
        userIds: [],
        creationDateFrom: null,
        creationDateTo: null,
        createdByIds: [],
        page: 0,
        pageSize: 50,
        orderBy: "creationDate",
        orderByDescending: true,
        status: []
      },
      clientOptions: [],
      users: [],
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: true
        },
        columnLines: false,
        store: {
          sorters: [{ field: "creationDate", ascending: false }]
        }
      },
      showAddUREditor: false,
      editUR: {},
      listeners: {
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.filter.orderBy = field;
            self.filter.orderByDescending = !ascending;
            self.changePage(0);
          }
        }
      },
      clientSearchChanged: false,
      filtersContainerHeight: 0,
      filterTextSelection: null,
      showReportRequestsModal: false
    };
  },
  methods: {
    ...mapActions("layout", [
      "showAlertSuccess",
      "toggleAssignToMeUtilizationIndex"
    ]),
    ...mapActions("client", [
      "fetchUtilizationStatuses",
      "fetchLevelsOfCare",
      "fetchReviewTypes"
    ]),
    changePage(page) {
      this.filter.page = page;
      this.searchURs(false);
      this.scrollGridToTop();
    },
    scrollGridToTop() {
      const grid = document.querySelector(".utilization-container .b-grid");
      grid.scrollTop = 0;
    },
    searchURs(delayed = true) {
      if (delayed) {
        if (this.lastTimeout) {
          clearTimeout(this.lastTimeout);
          this.lastTimeout = null;
        }
        this.lastTimeout = setTimeout(async () => {
          this.fetchURs();
        }, 1000);
      } else this.fetchURs();

      this.showResults = true;
    },
    async fetchURs() {
      const result = await urRecordServer.query({
        page: this.filter.page,
        pageSize: this.filter.pageSize,
        orderBy: this.filter.orderBy,
        orderByDescending: this.filter.orderByDescending,
        episodeOfCareId: this.filter.eoc.map(eoc => eoc.value),
        reviewTypeId: [],
        reviewDateFrom: this.filter.reviewDateFrom,
        reviewDateTo: this.filter.reviewDateTo,
        dueDateFrom: this.filter.dueDateFrom,
        dueDateTo: this.filter.dueDateTo,
        serviceId: this.filter.levelOfCare.map(eocId => eocId.value),
        locationId: [],
        caseManagerId: this.filter.userIds.map(uId => uId.value),
        createdAtFrom: formatStartDateSql(this.filter.creationDateFrom),
        createdAtTo: formatEndDateSql(this.filter.creationDateTo),
        createdBy: this.filter.createdByIds.map(uId => uId.value),
        utilizationStatusId: this.filter.status.map(u => u.value),
        assignedToMe: this.assignedToMe
      });
      this.list = result.records;
      this.listTotal = result.count;
    },
    async getUsers() {
      const users = await userServer.getMinimalUsers();
      this.users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user)
      }));
    },
    onModifyAddUR() {
      this.showAddUREditor = false;
      this.editUR = {};
      this.searchURs(false);
    },
    onCreateNew(lastUrId) {
      this.showAddUREditor = false;
      this.editUR = {};
      this.editUR.lastUrId = lastUrId;
      this.$nextTick(function() {
        this.showAddUREditor = true;
      });
    },
    formatDate(date) {
      return formatDateOnly(date);
    },
    addUR() {
      this.editUR = {};
      this.showAddUREditor = true;
    },
    async fetchClientOptions(search) {
      this.clientSearchChanged = true;
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      this.lastTimeout = setTimeout(async () => {
        if (!search || search.length == 0 || search.length >= 3) {
          const optionsResult = await eocServer.queryList(
            {
              searchPhrase: search,
              eocStatus:
                !search || search.length == 0 ? ["Active", "Pending"] : [],
              page: 1,
              pageSize: 50
            },
            {
              "Hide-Loading": true
            }
          );
          this.clientOptions = optionsResult.episodesOfCare.map(eoc => ({
            value: eoc.id,
            label: this.formatEocObj(eoc),
            data: eoc
          }));
          this.clientSearchChanged = false;
        } else {
          this.clientSearchChanged = false;
          this.clientOptions = [];
        }
      }, 1000);
    },
    removeClientFilter(index) {
      const newValue = [...this.filter.eoc];
      newValue.splice(index, 1);
      this.filterEoc = newValue;
    },
    removeReviewDateFilter() {
      this.filter.reviewDateFrom = null;
      this.filter.reviewDateTo = null;
    },
    removeDueDateFilter() {
      this.filter.dueDateFrom = null;
      this.filter.dueDateTo = null;
    },
    removeLevelOfCareFilter(index) {
      const newValue = [...this.filter.levelOfCare];
      newValue.splice(index, 1);
      this.filter.levelOfCare = newValue;
    },
    removeStatusFilter(index) {
      const newValue = [...this.filter.status];
      newValue.splice(index, 1);
      this.filter.status = newValue;
    },
    removeCreationDateFilter() {
      this.filter.creationDateFrom = null;
      this.filter.creationDateTo = null;
    },
    removeCreatedByFilter(index) {
      const newValue = [...this.filter.createdByIds];
      newValue.splice(index, 1);
      this.filterCreatedBy = newValue;
    },
    clearAllFilters() {
      this.filterEoc = [];
      this.filter.reviewDateFrom = null;
      this.filter.reviewDateTo = null;
      this.filter.dueDateFrom = null;
      this.filter.dueDateTo = null;
      this.filter.levelOfCare = [];
      this.filterUser = [];
      this.filter.creationDateFrom = null;
      this.filter.creationDateTo = null;
      this.filterCreatedBy = [];
      this.filter.status = [];
    },
    filterWidth() {
      return "250px";
    },
    computeHeights() {
      setTimeout(() => {
        const filtersContainerHeight = this.$refs.filtersContainer.clientHeight;
        this.filtersContainerHeight = filtersContainerHeight;
      }, 0);
    },
    updatePopper() {
      this.$refs.filterDropdown.updatePopper();
    },
    onFilterHide(event) {
      let ref = null;
      if (this.selectedFilter == "createdBy") {
        ref = this.$refs.createdByFilter;
      }
      if (this.selectedFilter == "patient") {
        ref = this.$refs.patientFilter;
      }
      if (this.filterTextSelection) {
        if (this.filterTextSelection) event.preventDefault();
        ref.highlightText();
        this.filterTextSelection = null;
      }
    },
    updateTextSelection(textSelection) {
      this.filterTextSelection = textSelection;
    },
    changeAssignedToMEToggle() {
      this.toggleAssignToMeUtilizationIndex();
      this.fetchURs();
    }
  },
  computed: {
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation,
      assignedToMe: state => state.assignedToMeUtilizationIndex,
      currentUser: state => state.currentUser
    }),
    ...mapState("client", {
      utilizationStatuses: state =>
        state.utilizationStatuses.map(status => ({
          value: status.id,
          label: status.name
        }))
    }),
    ...mapGetters("client", ["levelsOfCareCurrentLocation"]),
    ...mapGetters("layout", ["hasCurrentUserReportPermission"]),
    levelsOfCare() {
      return this.levelsOfCareCurrentLocation.map(levelOfCare => ({
        value: levelOfCare.id,
        label: levelOfCare.name
      }));
    },
    filterEoc: {
      get() {
        return this.filter.eoc;
      },
      set(newValues) {
        this.filter.eoc = newValues;
        this.searchURs();
      }
    },
    filterUser: {
      get() {
        return this.filter.userIds;
      },
      set(newValues) {
        this.filter.userIds = newValues;
        this.searchURs();
      }
    },
    filterCreatedBy: {
      get() {
        return this.filter.createdByIds;
      },
      set(newValues) {
        this.filter.createdByIds = newValues;
        this.searchURs();
      }
    },
    filterCreationDateRange: {
      get() {
        return {
          dateFrom: this.filter.creationDateFrom,
          dateTo: this.filter.creationDateTo
        };
      },
      set(newValue) {
        this.filter.creationDateFrom = newValue.dateFrom;
        this.filter.creationDateTo = newValue.dateTo;
      }
    },
    filterReviewDateRange: {
      get() {
        return {
          dateFrom: this.filter.reviewDateFrom,
          dateTo: this.filter.reviewDateTo
        };
      },
      set(newValue) {
        this.filter.reviewDateFrom = newValue.dateFrom;
        this.filter.reviewDateTo = newValue.dateTo;
      }
    },
    filterDueDateRange: {
      get() {
        return {
          dateFrom: this.filter.dueDateFrom,
          dateTo: this.filter.dueDateTo
        };
      },
      set(newValue) {
        this.filter.dueDateFrom = newValue.dateFrom;
        this.filter.dueDateTo = newValue.dateTo;
      }
    },
    hasFilters() {
      return (
        this.filter.eoc.length > 0 ||
        this.filter.reviewDateFrom ||
        this.filter.reviewDateTo ||
        this.filter.dueDateFrom ||
        this.filter.dueDateTo ||
        this.filter.levelOfCare.length > 0 ||
        this.filter.userIds.length > 0 ||
        this.filter.creationDateFrom ||
        this.filter.creationDateTo ||
        this.filter.createdByIds.length > 0 ||
        this.filter.status.length > 0
      );
    },
    items() {
      return this.list.map(item => ({
        ...item
      }));
    },
    columns() {
      let columns = [];
      const self = this;
      columns.push({
        text: "Patient",
        field: "patient",
        type: "template",
        flex: 1,
        editor: false,
        template: ({ record }) => this.formatEocObj(record.data.episodeOfCare),
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Insurance",
        field: "insurance",
        type: "template",
        flex: 1,
        editor: false,
        template: data =>
          data.record.data.insurance
            ? (data.record.data.insurance.company
                ? data.record.data.insurance.company.name
                : "") +
              " - " +
              (data.record.data.insurance.insuranceCoverage
                ? data.record.data.insurance.insuranceCoverage.name
                : "")
            : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Review Type",
        field: "reviewType",
        type: "template",
        flex: 1,
        editor: false,
        template: data =>
          data.record.data.reviewType ? data.record.data.reviewType.name : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Review Date",
        field: "reviewDate",
        type: "template",
        width: 90,
        editor: false,
        template: data =>
          data.record.data.reviewDate
            ? formatDateOnly(data.record.data.reviewDate)
            : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Reviewer",
        field: "reviewer",
        flex: 1,
        editor: false,
        type: "template",
        template: ({ record }) =>
          record.data.reviewer ? this.formatUser(record.data.reviewer) : ""
      });
      columns.push({
        text: "Status",
        field: "status",
        type: "template",
        width: 140,
        editor: false,
        template: ({ record }) => {
          if (!record.data.utilizationStatus) {
            return "";
          }

          const color = record.data.utilizationStatus.color;
          const name = record.data.utilizationStatus.name;
          return `
          <span class="badge-v2 py-2 badge-fixed-size text-white" style="background-color: ${color}">
            ${name}
          </span>`;
        }
      });
      columns.push({
        text: "Level of care",
        field: "service",
        type: "template",
        flex: 1,
        editor: false,
        template: ({ record }) =>
          record.data.service ? record.data.service.name : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Date Range",
        field: "dateRange",
        type: "template",
        width: 160,
        editor: false,
        template: data => {
          let dateRange = "";
          if (data.record.data.startDate)
            dateRange = formatDateOnly(data.record.data.startDate);
          if (data.record.data.startDate || data.record.data.endDate)
            dateRange += " - ";
          if (data.record.data.endDate)
            dateRange += formatDateOnly(data.record.data.endDate);
          return dateRange;
        },
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Number of units",
        field: "numberOfUnits",
        type: "template",
        flex: 1,
        editor: false,
        template: data => data.record.data.numberOfUnits,
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Authorization #",
        field: "authorization",
        type: "template",
        flex: 1,
        editor: false,
        template: data => data.record.data.authorizationNo,
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Creation",
        field: "creationDate",
        type: "template",
        width: 160,
        editor: false,
        template: data =>
          data.record.data.createdAt
            ? formatDate(data.record.data.createdAt)
            : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Created By",
        field: "createdBy",
        type: "template",
        flex: 1,
        editor: false,
        template: data =>
          data.record.data.createdBy
            ? this.formatUser(data.record.data.createdBy)
            : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Next Review",
        field: "nextReviewDate",
        type: "template",
        width: 160,
        editor: false,
        template: data =>
          data.record.data.nextReviewDate
            ? formatDate(data.record.data.nextReviewDate)
            : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "",
        type: "action",
        cellCls: "pointer-cell",
        field: "action",
        align: "right",
        width: 80,
        actions: [
          {
            tooltip: "More",
            renderer: ({ record }) => {
              return this.createDropdownButton({
                items: [
                  {
                    content: "Edit",
                    callback: () => {
                      this.editUR.id = record.id;
                      this.showAddUREditor = true;
                    }
                  },
                  {
                    content: "Delete",
                    callback: () => {
                      this.$dialog
                        .confirm(
                          {
                            title:
                              "Are you sure you want to delete this record?"
                          },
                          {
                            view: "confirm-delete"
                          }
                        )
                        .then(async () => {
                          let result = await urRecordServer.delete(record.id);
                          if (result.errorCode) {
                            this.$dialog.alert("Error: " + result.message);
                          } else {
                            this.searchURs(false);
                            this.showAlertSuccess();
                          }
                        })
                        .catch(function() {});
                    }
                  }
                ]
              });
            }
          }
        ]
      });
      return columns;
    },
    exportFilter() {
      return {
        eocIds: this.filter.eoc.map(eoc => eoc.value),
        levelOfCareIds: this.filter.levelOfCare.map(eocId => eocId.value),
        urStatusIds: this.filter.status.map(eocId => eocId.value),
        fromReviewDate: this.filter.reviewDateFrom,
        toReviewDate: this.filter.reviewDateTo,
        fromDueDate: this.filter.dueDateFrom,
        toDueDate: this.filter.dueDateTo,
        userIds: this.filter.createdByIds.map(uId => uId.value),
        fromCreation: this.filter.creationDateFrom,
        toCreation: this.filter.creationDateTo,
        orderBy: this.filter.orderBy,
        sort: this.filter.orderByDescending ? "DESC" : "ASC",
        locationIds: [this.selectedLocation],
        assignedToMe: this.assignedToMe.toString()
      };
    }
  },
  watch: {
    showing: {
      handler: function(newValue) {
        if (newValue) {
          this.fetchReviewTypes();
          this.searchURs(false);
          this.getUsers();
          this.fetchClientOptions("");
          this.computeHeights();
          this.fetchUtilizationStatuses();
          this.fetchLevelsOfCare();
        }
      }
    },
    "filter.reviewDateFrom": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    "filter.reviewDateTo": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    "filter.dueDateFrom": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    "filter.dueDateTo": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    "filter.createdByIds": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    "filter.creationDateFrom": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    "filter.creationDateTo": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    "filter.levelOfCare": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    "filter.eoc": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    "filter.status": function() {
      this.filter.page = 0;
      this.searchURs();
      this.computeHeights();
    },
    selectedFilter: function() {
      this.$refs.filterDropdown.updatePopper();
    }
  }
};
</script>

<style scoped>
.container-main {
  height: 45px;
}
.container-main:hover {
  cursor: pointer;
}
.b-dropdown-form:focus {
  outline: none !important;
}

.filter-values {
  width: 250px;
}
.filter-value {
  min-width: 100px;
  height: 29px;
  color: #a6a6a6;
  font-size: 14px;
  padding-left: 10px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.filter-values {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filters-container >>> .container-filter-main-menu {
  min-width: 250px;
  left: -17px;
}
.vertical-separator {
  width: 1px;
  border-left: 1px solid;
  height: 100%;
}
.color-filter {
  color: #909db8;
}
.utilization-container >>> .b-grid-container .b-container {
  max-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  );
  min-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  ) !important;
}
</style>
<style>
.container-main-menu {
  max-height: 500px;
  overflow-y: auto;
}
.b-calendar-grid-help {
  display: none;
}
.b-calendar .b-calendar-grid {
  border: none;
}
.b-calendar .b-calendar-inner {
  min-width: 200px !important;
}
</style>
